<template>
  <div class="propaganda" :id="appName+'_box'">
    <header>
      <img class="logo" src="../assets/imgs/homepage/yl_logo.png" alt="">
      <div>
        <!-- <p class="p1">所见即所得的人机合译平台</p>
        <p class="p2">A WYSIWYG CAT PLATFORM</p>
        <img src="../assets/imgs/propaganda/introduce.png" alt=""> -->
      </div>
      <el-button style="-webkit-tap-highlight-color:transparent;" type="text" @click=jump>{{content}}</el-button>
      <!-- <el-button v-show="!flag" type="text" @click=register>注册</el-button> -->
    </header>
    <div class="wraper">
      <p class="title">产品特点</p>
      <p class="tit">Features of Product</p>
      <img class="one" :src="imgsList.img1" alt="">
      <div class="modular_1">
        <span class="modular_tit"><span>01</span>{{textObj.t4}}</span>
        <p class="modular_1_p">{{textObj.t5}}</p>
        <img :src="imgsList.img2" alt="">
      </div>
      <div class="modular_1">
        <span class="modular_tit"><span>02</span>{{textObj.t6}}</span>
        <p class="modular_1_p">{{textObj.t7}}</p>
        <img :src="imgsList.img3" alt="">
      </div>
      <div class="modular_1">
        <span class="modular_tit"><span>03</span>{{textObj.t8}}</span>
        <p class="modular_1_p">{{textObj.t9}}</p>
        <img :src="imgsList.img4" alt="">
      </div>
      <div class="modular_1">
        <span class="modular_tit"><span>04</span>{{textObj.t10}}</span>
        <p class="modular_1_p">{{textObj.t11}}</p>
        <!-- <img :src="imgsList.img4" alt=""> -->
      </div>
      <!-- <div class="modular_1">
        <span><span>01</span>{{textObj.t4}}</span>
        <p class="modular_1_p">·简单直观的多人协作方式，多人协作从未如 此简单。</p>
      </div> -->
    </div>
    <div class="footer">
      <div class="footer_top">
        <div class="footer_top_ronbg">
          <img src="../assets/imgs/home/fy_code.png" alt="">
          <span>飞译公众号</span>
        </div>
        <div class="footer_top_ronbg">
          <img src="../assets/imgs/home/zkfy_code.png" alt="">
          <span>中科凡语公众号</span>
        </div>
      </div>
      <div class="footer_middle">
        <p>北京中科凡语科技有限公司 ©2019 版</p>
        <p>Beijing Fanyu Technology Co., Ltd ©2019</p>
        <p>邮箱：guanghua.li@anylangtech.com</p>
        <p>电话：010-61934155</p>
        <p>地址：北京市海淀区知春路甲63号卫星大厦1006室</p>
      </div>
      <div class="footer_footer">
        <span>京IPC备18045685-2</span>
        <span>京公网安备11010802032721号</span>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="50%" style="text-align:center" top="40vh">
      <span v-if="!wxTips">请在PC端打开</span>
      <span v-if="wxTips">您已注册过飞译，请在PC端登录</span>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      dialogVisible: false,
      url: "", // http://dev.anylangtech.com/kexin/registerTurn.html //https://lightingyee.com/h5/registerTurn.html
      content: "",
      wxTips: false,// 已经是用户在微信内打开
      appName: "",
      textObj: {
        t1: "",
        t2: "",
        t3: "选择最适合您的版本",
        t4: " 多语种、多领域",
        t5: "·32个语种，中英7个细分领域，覆盖大多数笔译业务场景",
        t6: " 所见即所得",
        t7: "·首款所见即所得的在线编辑界面，翻译全程保留格式，全新翻译体验 ",
        t8: " 人机合译",
        t9: "·翻译过程单词补全，实时人机互动，人机合译，共同进步",
        t10: " 多人协作",
        t11: "·简单直观的多人协作方式，项目进度、项目统计尽在掌握 ",
        t12: "全语种、多领域的新一代CAT，让译者专注翻译",
      },
      logoImg: require("../assets/imgs/homepage/logo.png"),
      imgsList: {
        img1: require("../assets/imgs/product/complex.png"),
        img2: require("../assets/imgs/product/see_get.png"),
        img3: require("../assets/imgs/product/machine _translation.png"),
        img4: require("../assets/imgs/product/locked _repetition.png"),
      }
    };
  },
  async created() {
    if (process.env.NODE_ENV === "production") {
      this.url = "https://lightingyee.com/h5/registerTurn.html"; // 正式环境
    } else {
      this.url = "http://dev.anylangtech.com/kexin/registerTurn.html";
    }
    this.appName = process.env.VUE_APP_NAME;
    switch (this.appName) {
      case 'hospital': // 医疗
        this.textObj = {
          t1: "",
          t2: "",
          t3: "选择最适合您的版本",
          t4: " 医疗机翻引擎",
          t5: "·针对医疗领域优化、译文更符合医疗文件风格",
          t6: " 精准医疗术语",
          t7: "·支持实时添加术语、内置150万条医疗词典",
          t8: " 所见即所得",
          t9: "·首款所见即所得的在线编辑界面，翻译全程保留格式，全新翻译体验",
          t10: " 多人协作",
          t11: "·简单直观的多人协作方式，项目进度、项目统计尽在掌握 ",
          t12: "专门为医疗翻译场景而打造的新一代CAT"
        }
        this.logoImg = require("../assets/imgs/homepage/yl_logo.png");
        this.imgsList = {
          img1: require("../assets/imgs/product/yl_01.png"),
          img2: require("../assets/imgs/product/yl_02.png"),
          img3: require("../assets/imgs/product/yl_03.png"),
          img4: require("../assets/imgs/product/yl_04.png"),
        }
        break;
      case 'school': // 高校
        this.textObj = {
          t1: "",
          t2: "",
          t3: "选择最适合您的版本",
          t4: " 多语种、多领域",
          t5: "·32个语种，中英7个细分领域，覆盖多语种教学、实践场景",
          t6: " 作业模式",
          t7: "·一键分配作业，作业评分",
          t8: " 所见即所得",
          t9: "·首款所见即所得的在线编辑界面，翻译全程保留格式，全新翻译体验",
          t10: " 多人协作",
          t11: "·简单直观的多人协作方式，项目进度、项目统计尽在掌握 ",
          t12: "面向高校翻译教学、翻译生产实践的新一代CAT"
        }
        this.logoImg = require("../assets/imgs/homepage/yl_logo.png");
        this.imgsList = {
          img1: require("../assets/imgs/product/gx_01.png"),
          img2: require("../assets/imgs/product/gx_02.png"),
          img3: require("../assets/imgs/product/gx_03.png"),
          img4: require("../assets/imgs/product/gx_04.png"),
        }
        break;
      default:
        break;
    }
    if (window.innerWidth > 768) {
      this.$router.push({
        path: "/index",
      })
    } else {
      await this.queryUsers()
    }
  },
  methods: {
    register() {
      window.location.href = `${this.url}?key=${this.key}`
    },
    jump() {
      if (this.content == "登录") {
        this.dialogVisible = true;
      } else {
        // if (this.wxTips) {
        //   this.dialogVisible = true;
        // } else {
        //   window.location.href = `${this.url}?key=${this.key}`
        // }
        window.location.href = `${this.url}?key=${this.key}`
      }

    },
    //获取地址栏的参数
    getUrlParam(name) {
      var match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.href);
      return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    },
    async queryUsers() {
      let that = this
      let accessToken = await this.getUrlParam("accessToken")
      let openId = await this.getUrlParam("openId")
      if (!accessToken && !openId) {
        if (!that.getUrlParam("code")) {
          that.content = "注册"
          return
        } else {
          that.content = "注册"
          return
        }
      }

      let params = {
        openId,
        accessToken
      }
      let url = "/user/get_userInfo_code"
      const response = await this.catReq1Service(url, params, "get")
      if (response.resultCode == "1") {
        if (response.result.flag) {
          that.content = "注册"
          that.wxTips = true
        } else {
          that.content = "注册"
        }
        this.key = this.$Base64.encode(JSON.stringify(response.result))
      }
    },

  }
};
</script>

<style lang="less" scoped>
// .propaganda {
//   height: 100%;
//   background: url("../assets/imgs/propaganda/iphone-bg.jpg") no-repeat;
//   background-size: cover;
// }
/* 通用样式 start */
#standard_box {
  .wraper{
    background: url("../assets/imgs/propaganda/ph_ty_bg.png") center
      no-repeat;
    background-size: 100% 100%;
  }
  header {
    background: url("../assets/imgs/homepage/tongyongbna-toutu.png") center
      no-repeat;
    background-size: 100% 100%;
    .el-button{
      background: #4C63F1;
    }
  }
  .modular_tit {
    background: transparent;
    color: #65adff;
  }
  .footer {
    background: linear-gradient(-47deg, #2638e7 0%, #2ecaf0 100%);
  }
}
/* 通用样式 end */
/* 医疗样式 start */
#hospital_box {
  .wraper{
    background: url("../assets/imgs/propaganda/ph_yl_bg.png") center
      no-repeat;
    background-size: cover;
  }
  header {
    background: url("../assets/imgs/homepage/yiliaoban-toutu.png") center
      no-repeat;
    background-size: 100% 100%;
    .el-button {
      background: #296bc8;
    }
  }
  .modular_tit {
    background: transparent;
    color: #3674ba;
    span {
      background: #3674ba;
      color: #ffffff;
      border-radius: 4px;
    }
  }
  .footer {
    background: linear-gradient(-55deg, #174d98, #4a8dd1);
  }
}
/* 医疗样式 end */
/* 高校样式 start */
#school_box {
  .wraper{
    background: url("../assets/imgs/propaganda/ph_gx_bg.png") center
      no-repeat;
    background-size: cover;
  }
  header {
    background: url("../assets/imgs/homepage/gaoxiaobanben-toutu.png") center
      no-repeat;
    background-size: 100% 100%;
    .el-button {
      background: #4c63f1;
    }
  }
  .modular_tit {
    background: #3e82f2;
    color: #ffffff;
  }
  .footer {
    background: #4d64ca;
  }
}
/* 高校样式 end */
header {
  position: relative;
  width: 100%;
  height: 30vh;
  background-image: url(../assets/imgs/propaganda/top_bg.png);
  background-size: 100% 100%;
  .logo {
    margin-left: 10%;
    margin-top: 4%;
    width: 10%;
  }
  div {
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #151d6d;
    box-sizing: border-box;
    padding-left: 21%;
    .p1 {
      font-size: 20px !important;
    }
    .p2 {
      margin-top: 1%;
      font-size: 12px !important;
    }
    img {
      width: 70%;
    }
  }
  .el-button {
    position: absolute;
    right: 7%;
    top: 8%;
    width: 67px;
    height: 30px;
    background: rgba(75, 99, 241, 1);
    color: white;
    line-height: 0px;
    border: 1px solid rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(75, 99, 241, 0.5);
    border-radius: 30px;
  }
}
.wraper {
  width: 100%;
  // height: 1666px;
  padding: 20px 0;
  background-image: url("../assets/imgs/propaganda/zj_bg.png");
  background-size: cover;
  .title {
    font-size: 19px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #151d6d;
    padding-top: 5%;
    margin-left: 40%;
  }
  .tit {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #151d6d;
    margin-left: 33%;
  }
  .one {
    width: 67%;
    height: 10%;
    position: relative;
    padding-top: 4%;
    left: 17%;
  }
  .modular_1 {
    position: relative;
    width: 100%;
    .modular_tit {
      display: inline-block;
      // width: 130px;
      padding: 0 5px;
      font-weight: bold;
      height: 27px;
      background: linear-gradient(
        90deg,
        rgba(73, 127, 245, 1) 0%,
        rgba(101, 173, 255, 1) 100%
      );
      border-radius: 2px;
      font-size: 17px;
      font-family: Microsoft YaHei;
      color: white;
      text-align: center;
      line-height: 27px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 5%;
    }
    .modular_1_p {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      position: relative;
      // text-align: center;
      width: 58vw;
      margin: 0 auto;
      margin-top: 2%;
    }
    img {
      width: 75%;
      height: 10%;
      position: relative;
      padding-top: 13%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.footer {
  position: relative;
  width: 100%;
  height: 325px;
  text-align: center;
  background: linear-gradient(
    -47deg,
    rgba(37, 55, 231, 1) 0%,
    rgba(45, 201, 239, 1) 100%
  );
  .footer_top {
    padding-top: 10%;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    height: 77px;
    display: flex;
    justify-content: space-between;
    .footer_top_ronbg {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      span {
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        margin-top: 3%;
        font-size: 14px;
      }
    }
    img {
      width: 60%;
    }
  }
  .footer_middle {
    // padding-left: 15%;
    margin: 0 auto;
    margin-top: 15%;
    p {
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      font-size: 12px;
      width: 280px;
      text-align: center;
      height: 20px;
      line-height: 20px;
      margin: 0 auto;
    }
  }
  .footer_footer {
    width: 300px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #e5dada;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    position: relative;
    // left: 15%;
    margin: 0 auto;
    margin-top: 2%;
  }
}
</style>
